import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/discovery-settings/edit/$id/$organizationId')({
  beforeLoad: () => getTitleContextSlice('Edit Profile'),
});
